// extracted by mini-css-extract-plugin
module.exports = {"Container":"styles_Container__3sRYx","TitleContainer":"styles_TitleContainer__2OsB0","FormContainer":"styles_FormContainer__f_xAs"};